(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 85356:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(64141);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 64141:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var pages_homev2__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67497);
/* harmony import */ var src_constants_routes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54166);


var pageId = src_constants_routes__WEBPACK_IMPORTED_MODULE_1__/* .routes.home.page */ ._.home.page;
pages_homev2__WEBPACK_IMPORTED_MODULE_0__["default"].pageId = pageId;
pages_homev2__WEBPACK_IMPORTED_MODULE_0__["default"].pagePathView = "/";
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (pages_homev2__WEBPACK_IMPORTED_MODULE_0__["default"]);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2522,3053,7427,41,7497,9774,2888,179], function() { return __webpack_exec__(85356); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);